import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { X } from 'react-bootstrap-icons';
import Calendar, { CalendarProps } from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import './ModalDatePicker.scss';

interface ModalDatePickerProps {
  show: boolean;
  onHide: () => void;
  title: string;
  value: Date | null;
  onChange: CalendarProps['onChange'];
  maxDate?: Date;
  minDate?: Date;
}

const ModalDatePicker: React.FC<ModalDatePickerProps> = ({
  show,
  onHide,
  title,
  value,
  onChange,
  maxDate,
  minDate
}) => {  const handleDateChange: CalendarProps['onChange'] = (date) => {
    if (onChange) {
      onChange(date, {} as React.MouseEvent<HTMLButtonElement>);
    }
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} centered className="modal-date-picker">
      <Modal.Header>
        <div className="form-modal-title-container">
          <Modal.Title className="form-modal-title">{title}</Modal.Title>
        </div>
        <Button variant="none" className="modal-close-button" onClick={onHide}>
          <X size={24} />
        </Button>
      </Modal.Header>
      <Modal.Body>
        <div className="modal-calendar-container">
          <Calendar
            onChange={handleDateChange}
            value={value || new Date()}
            locale="es-ES"
            className="mp-form-calendar responsive"
            maxDate={maxDate}
            minDate={minDate}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ModalDatePicker;
